// Every htui drawer and dialog renders this, and only while it is open.
const OPEN_OVERLAY = ".chakra-modal__content";

// Chakra mounts each portal in one of these, appended to the body; a portal opened from inside another nests in it.
const BODY_PORTAL = "body > .chakra-portal";

const isInert = (element: HTMLElement) => {
  let node: HTMLElement | null = element;
  while (node && !node.inert) node = node.parentElement;
  return node !== null;
};

/** The open drawer or dialog drawn last, which is the one on top. Inert ones belong to the page under settings. */
export const topOpenOverlay = (): HTMLElement | undefined => {
  const open = [...document.querySelectorAll<HTMLElement>(OPEN_OVERLAY)].filter(
    (overlay) => !isInert(overlay),
  );
  return open[open.length - 1];
};

/** Body portals that hold an open drawer or dialog. */
export const portalsWithOpenOverlay = (): HTMLElement[] =>
  [...document.querySelectorAll<HTMLElement>(BODY_PORTAL)].filter(
    (portal) => portal.querySelector(OPEN_OVERLAY) !== null,
  );

/** Hands Escape to an overlay, which closes itself, for when focus sits outside it and it would never see the key. */
export const sendEscape = (overlay: HTMLElement) => {
  overlay.dispatchEvent(
    new KeyboardEvent("keydown", {
      key: "Escape",
      bubbles: true,
      cancelable: true,
    }),
  );
};
